import { Reaction } from 'mobx';
import { incrementReactionCount } from 'owa-analytics';

export function patchReaction(): void {
    // We use a scheduled reaction as a proxy for a render
    const originalSchedule = Reaction.prototype.schedule_;
    Reaction.prototype.schedule_ = function scheduleWrapper() {
        // This type discrepancy will exist while upgrating mobx versions
        let isScheduled: boolean;
        if (typeof this.isScheduled === 'function') {
            isScheduled = (this.isScheduled as () => boolean)();
        } else {
            isScheduled = this.isScheduled as unknown as boolean;
        }

        // If the reaction is already scheduled, then this doesn't count as another render
        if (!isScheduled) {
            incrementReactionCount();
        }

        // Actually call schedule
        originalSchedule.apply(this);
    };
}
